import React, { useState } from 'react';
import { Header } from './components/Header';
import { Pillars } from './components/Pillars';
import { JobsCTA } from './components/JobsCTA';
import { SocialFeed } from './components/SocialFeed';
import { Footer } from './components/Footer';
import { Navigation, ServiceType } from './components/Navigation';
import { OrderForm } from './components/OrderForm';
import { CateringCatalog } from './components/CateringCatalog';
import { BookTableModal } from './components/BookTableModal';
import { X } from 'lucide-react';
export function App() {
  const [selectedService, setSelectedService] = useState<ServiceType | null>(null);
  const [showJobs, setShowJobs] = useState(false);
  const [showBookTable, setShowBookTable] = useState(false);
  const [businessOrderTrigger, setBusinessOrderTrigger] = useState(0);
  const handleScrollToCatalog = () => {
    document.getElementById('catalog')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const handleBusinessOrder = () => {
    document.getElementById('catalog')?.scrollIntoView({
      behavior: 'smooth'
    });
    setBusinessOrderTrigger(prev => prev + 1);
  };
  return <div className="min-h-screen w-full bg-[#F2EDE4] text-[#1A1A1A] font-sans selection:bg-[#7C8062] selection:text-white flex flex-col" data-id="element-0">
      <Navigation onOrderClick={type => setSelectedService(type)} onJobsClick={() => setShowJobs(true)} onBusinessOrder={handleBusinessOrder} onScrollToCatalog={handleScrollToCatalog} data-id="element-1" />

      <main className="flex-grow flex flex-col items-center w-full" data-id="element-2">
        <Header onScrollToCatalog={handleScrollToCatalog} onBusinessOrder={handleBusinessOrder} onBookTable={() => setShowBookTable(true)} onJobs={() => setShowJobs(true)} data-id="element-3" />

        <Pillars data-id="element-4" />

        <div className="w-full max-w-5xl mx-auto space-y-12 md:space-y-24 pb-20 px-4 sm:px-6 lg:px-8" data-id="element-5">
          <CateringCatalog onOrderClick={type => setSelectedService(type)} businessOrderTrigger={businessOrderTrigger} data-id="element-6" />
          <div className="w-full h-px bg-[#7C8062]/20 max-w-xs mx-auto" data-id="element-7" />
          <SocialFeed data-id="element-8" />
        </div>
      </main>

      <Footer data-id="element-9" />

      {selectedService && <OrderForm type={selectedService} onClose={() => setSelectedService(null)} data-id="element-10" />}

      {showBookTable && <BookTableModal onClose={() => setShowBookTable(false)} data-id="element-11" />}

      {/* Jobs Page Overlay */}
      {showJobs && <div className="fixed inset-0 z-50 bg-[#F2EDE4] overflow-y-auto" data-id="element-12">
          <div className="sticky top-0 z-10 bg-[#F2EDE4] border-b border-[#7C8062]/15 shadow-sm" data-id="element-13">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-14" data-id="element-14">
              <button onClick={() => setShowJobs(false)} className="flex items-center gap-2 text-sm font-medium text-[#1A1A1A]/70 hover:text-[#7C8062] transition-colors" data-id="element-15">
                ← Tillbaka
              </button>
              <h1 className="text-lg font-serif text-[#1A1A1A]" data-id="element-16">
                Jobba hos oss
              </h1>
              <button onClick={() => setShowJobs(false)} className="p-2 text-[#1A1A1A]/50 hover:text-[#1A1A1A] hover:bg-[#7C8062]/10 rounded-full transition-colors" aria-label="Stäng" data-id="element-17">
                <X className="w-5 h-5" data-id="element-18" />
              </button>
            </div>
          </div>
          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-19">
            <JobsCTA data-id="element-20" />
          </div>
        </div>}
    </div>;
}